import toast from "react-hot-toast";

/** Labels for supplier email skip reasons (settings + pending orders UI). */
export const PARTY_EMAIL_SKIP_LABELS = {
  disabled: "Sending disabled in settings",
  notify_off: "Supplier notify turned off",
  not_email_order_type: "Order type is not Email",
  no_party_email: "No supplier email in Party master",
  no_smtp: "SMTP not configured",
  no_new_attachments: "Already emailed (no new files)",
};

export function partyEmailSkipLabel(reason) {
  const r = String(reason || "").trim();
  return PARTY_EMAIL_SKIP_LABELS[r] || (r ? r.replace(/_/g, " ") : "Skipped");
}

export function partyEmailStatusBadge(order) {
  const sendType = String(order?.sendType || "").trim().toLowerCase();
  if (sendType !== "email") return null;

  const status = String(order?.partyEmailStatus || "").trim().toLowerCase();
  if (status === "sent") {
    return {
      label: order.partyEmailLastTo ? `Emailed ${order.partyEmailLastTo}` : "Emailed",
      className: "bg-emerald-50 text-emerald-800 border-emerald-200",
    };
  }
  if (status === "failed") {
    return {
      label: "Email failed",
      className: "bg-rose-50 text-rose-800 border-rose-200",
      title: order.partyEmailLastError || "",
    };
  }
  if (status === "skipped") {
    return {
      label: partyEmailSkipLabel(order.partyEmailSkipReason),
      className: "bg-amber-50 text-amber-900 border-amber-200",
    };
  }
  return {
    label: "Email pending",
    className: "bg-slate-50 text-slate-600 border-slate-200",
  };
}

/** Toast + return whether send succeeded. */
export function toastPartyEmailResult(res, { quietSkips = false } = {}) {
  const d = res?.data;
  if (!d) return false;
  if (d.skipped) {
    const reason = d.reason;
    if (quietSkips && ["no_smtp", "disabled", "notify_off", "not_email_order_type"].includes(reason)) {
      return false;
    }
    if (reason === "no_party_email") {
      toast("Add supplier email in Party master to send.", { icon: "ℹ️", duration: 5000 });
    } else if (reason === "no_new_attachments") {
      toast("Nothing new to email — use Resend to send again.", { icon: "ℹ️", duration: 5000 });
    } else {
      toast(partyEmailSkipLabel(reason), { icon: "ℹ️", duration: 5000 });
    }
    return false;
  }
  if (d.ok && d.to) {
    const verb = d.summaryEmail ? "notified" : "emailed";
    const again = d.resent ? " (resent)" : "";
    toast.success(`Supplier ${verb} (${d.to})${again}`);
    return true;
  }
  return false;
}
